export default __webpack_public_path__ + "static/media/data.b3888a6e.jpg";